module.exports = __webpack_public_path__ + "static/scale-model-of-payton-glass-activity-center-in-louisville-kentucky-9bb0d023bd3e2694061963bddd15cdd1.png";